/**
 * bpmutils API
 * bpmutils API
 *
 * OpenAPI spec version: v20210817.01
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { ActivitiAddCandidateGroupReq } from '../model/activitiAddCandidateGroupReq';
import { ActivitiAddCandidateGroupResp } from '../model/activitiAddCandidateGroupResp';
import { ActivitiAddCandidateUserReq } from '../model/activitiAddCandidateUserReq';
import { ActivitiAddCandidateUserResp } from '../model/activitiAddCandidateUserResp';
import { ActivitiAddCommentReq } from '../model/activitiAddCommentReq';
import { ActivitiAddCommentResp } from '../model/activitiAddCommentResp';
import { ActivitiAddMultiTaskAssigneeReq } from '../model/activitiAddMultiTaskAssigneeReq';
import { ActivitiAddMultiTaskAssigneeResp } from '../model/activitiAddMultiTaskAssigneeResp';
import { ActivitiClaimTaskReq } from '../model/activitiClaimTaskReq';
import { ActivitiClaimTaskResp } from '../model/activitiClaimTaskResp';
import { ActivitiCompleteTaskReq } from '../model/activitiCompleteTaskReq';
import { ActivitiCompleteTaskResp } from '../model/activitiCompleteTaskResp';
import { ActivitiDeleteCandidateGroupReq } from '../model/activitiDeleteCandidateGroupReq';
import { ActivitiDeleteCandidateGroupResp } from '../model/activitiDeleteCandidateGroupResp';
import { ActivitiDeleteCandidateUserReq } from '../model/activitiDeleteCandidateUserReq';
import { ActivitiDeleteCandidateUserResp } from '../model/activitiDeleteCandidateUserResp';
import { ActivitiDeployBPMFileResp } from '../model/activitiDeployBPMFileResp';
import { ActivitiDeployProcessReq } from '../model/activitiDeployProcessReq';
import { ActivitiDeployProcessResp } from '../model/activitiDeployProcessResp';
import { ActivitiProcessDefTasksReq } from '../model/activitiProcessDefTasksReq';
import { ActivitiProcessDefTasksResp } from '../model/activitiProcessDefTasksResp';
import { ActivitiProcessImgResp } from '../model/activitiProcessImgResp';
import { ActivitiProcessVariableResp } from '../model/activitiProcessVariableResp';
import { ActivitiProcessVariablesResp } from '../model/activitiProcessVariablesResp';
import { ActivitiQueryCurrentTaskReq } from '../model/activitiQueryCurrentTaskReq';
import { ActivitiQueryCurrentTaskResp } from '../model/activitiQueryCurrentTaskResp';
import { ActivitiQueryPendingCountReq } from '../model/activitiQueryPendingCountReq';
import { ActivitiQueryPendingCountResp } from '../model/activitiQueryPendingCountResp';
import { ActivitiQueryPendingReq } from '../model/activitiQueryPendingReq';
import { ActivitiQueryPendingResp } from '../model/activitiQueryPendingResp';
import { ActivitiQueryProcessInstanceReq } from '../model/activitiQueryProcessInstanceReq';
import { ActivitiQueryProcessInstanceResp } from '../model/activitiQueryProcessInstanceResp';
import { ActivitiQueryProcessVariableReq } from '../model/activitiQueryProcessVariableReq';
import { ActivitiQuerySubstitutionCountReq } from '../model/activitiQuerySubstitutionCountReq';
import { ActivitiQuerySubstitutionCountResp } from '../model/activitiQuerySubstitutionCountResp';
import { ActivitiQuerySubstitutionHisReq } from '../model/activitiQuerySubstitutionHisReq';
import { ActivitiQuerySubstitutionHisResp } from '../model/activitiQuerySubstitutionHisResp';
import { ActivitiQuerySubstitutionReq } from '../model/activitiQuerySubstitutionReq';
import { ActivitiQuerySubstitutionResp } from '../model/activitiQuerySubstitutionResp';
import { ActivitiQueryTaskReq } from '../model/activitiQueryTaskReq';
import { ActivitiQueryTaskResp } from '../model/activitiQueryTaskResp';
import { ActivitiSetAssigneeReq } from '../model/activitiSetAssigneeReq';
import { ActivitiSetAssigneeResp } from '../model/activitiSetAssigneeResp';
import { ActivitiStartProcessReq } from '../model/activitiStartProcessReq';
import { ActivitiStartProcessResp } from '../model/activitiStartProcessResp';
import { ActivitiTerminateProcessReq } from '../model/activitiTerminateProcessReq';
import { ActivitiTerminateProcessResp } from '../model/activitiTerminateProcessResp';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class ActivitiProcess_Service {

  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
        this.basePath = basePath;
    }
    if (configuration) {
        this.configuration = configuration;
        this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * 新增處理群組
   * 新增處理群組(CandidateGroup)
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addCandidateGroupUsingPOST(body?: ActivitiAddCandidateGroupReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiAddCandidateGroupResp>;
  public addCandidateGroupUsingPOST(body?: ActivitiAddCandidateGroupReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiAddCandidateGroupResp>>;
  public addCandidateGroupUsingPOST(body?: ActivitiAddCandidateGroupReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiAddCandidateGroupResp>>;
  public addCandidateGroupUsingPOST(body?: ActivitiAddCandidateGroupReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiAddCandidateGroupResp>('post', `${this.basePath}/bpmutils/activiti/addCandidateGroup`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 新增處理者
   * 新增處理者(CandidateUser)
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addCandidateUserUsingPOST(body?: ActivitiAddCandidateUserReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiAddCandidateUserResp>;
  public addCandidateUserUsingPOST(body?: ActivitiAddCandidateUserReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiAddCandidateUserResp>>;
  public addCandidateUserUsingPOST(body?: ActivitiAddCandidateUserReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiAddCandidateUserResp>>;
  public addCandidateUserUsingPOST(body?: ActivitiAddCandidateUserReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiAddCandidateUserResp>('post', `${this.basePath}/bpmutils/activiti/addCandidateUser`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 增加任務備註
   * 增加任務備註
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addCommentUsingPOST(body?: ActivitiAddCommentReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiAddCommentResp>;
  public addCommentUsingPOST(body?: ActivitiAddCommentReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiAddCommentResp>>;
  public addCommentUsingPOST(body?: ActivitiAddCommentReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiAddCommentResp>>;
  public addCommentUsingPOST(body?: ActivitiAddCommentReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiAddCommentResp>('post', `${this.basePath}/bpmutils/activiti/addComment`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 新增任務加簽人員
   * 新增任務加簽人員
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addMultiTaskAssigneeUsingPOST(body?: ActivitiAddMultiTaskAssigneeReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiAddMultiTaskAssigneeResp>;
  public addMultiTaskAssigneeUsingPOST(body?: ActivitiAddMultiTaskAssigneeReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiAddMultiTaskAssigneeResp>>;
  public addMultiTaskAssigneeUsingPOST(body?: ActivitiAddMultiTaskAssigneeReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiAddMultiTaskAssigneeResp>>;
  public addMultiTaskAssigneeUsingPOST(body?: ActivitiAddMultiTaskAssigneeReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiAddMultiTaskAssigneeResp>('post', `${this.basePath}/bpmutils/activiti/addMultiTaskAssignee`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 領取案件
   * 領取案件
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public claimTaskUsingPOST(body?: ActivitiClaimTaskReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiClaimTaskResp>;
  public claimTaskUsingPOST(body?: ActivitiClaimTaskReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiClaimTaskResp>>;
  public claimTaskUsingPOST(body?: ActivitiClaimTaskReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiClaimTaskResp>>;
  public claimTaskUsingPOST(body?: ActivitiClaimTaskReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiClaimTaskResp>('post', `${this.basePath}/bpmutils/activiti/claimTask`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 審核節點
   * 審核節點
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public completeTaskUsingPOST(body?: ActivitiCompleteTaskReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiCompleteTaskResp>;
  public completeTaskUsingPOST(body?: ActivitiCompleteTaskReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiCompleteTaskResp>>;
  public completeTaskUsingPOST(body?: ActivitiCompleteTaskReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiCompleteTaskResp>>;
  public completeTaskUsingPOST(body?: ActivitiCompleteTaskReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiCompleteTaskResp>('post', `${this.basePath}/bpmutils/activiti/completeTask`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 移除原本的群組
   * 移除原本的群組(CandidateGroup)
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCandidateGroupUsingPOST(body?: ActivitiDeleteCandidateGroupReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiDeleteCandidateGroupResp>;
  public deleteCandidateGroupUsingPOST(body?: ActivitiDeleteCandidateGroupReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiDeleteCandidateGroupResp>>;
  public deleteCandidateGroupUsingPOST(body?: ActivitiDeleteCandidateGroupReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiDeleteCandidateGroupResp>>;
  public deleteCandidateGroupUsingPOST(body?: ActivitiDeleteCandidateGroupReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiDeleteCandidateGroupResp>('post', `${this.basePath}/bpmutils/activiti/deleteCandidateGroup`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 移除原本的處理者
   * 移除原本的處理者(CandidateUser)
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCandidateUserUsingPOST(body?: ActivitiDeleteCandidateUserReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiDeleteCandidateUserResp>;
  public deleteCandidateUserUsingPOST(body?: ActivitiDeleteCandidateUserReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiDeleteCandidateUserResp>>;
  public deleteCandidateUserUsingPOST(body?: ActivitiDeleteCandidateUserReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiDeleteCandidateUserResp>>;
  public deleteCandidateUserUsingPOST(body?: ActivitiDeleteCandidateUserReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiDeleteCandidateUserResp>('post', `${this.basePath}/bpmutils/activiti/deleteCandidateUser`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 流程上傳部署
   * 流程檔案上傳部署
   * @param file
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deployBPMNFileUsingPOSTForm(file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<ActivitiDeployBPMFileResp>;
  public deployBPMNFileUsingPOSTForm(file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiDeployBPMFileResp>>;
  public deployBPMNFileUsingPOSTForm(file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiDeployBPMFileResp>>;
  public deployBPMNFileUsingPOSTForm(file?: Blob, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'multipart/form-data'
    ];

    const canConsumeForm = this.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): void; };
    let useForm = false;
    let convertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    }

    if (file !== undefined) {
      formParams = formParams.append('file', <any>file) as any || formParams;
    }

    return this.httpClient.request<ActivitiDeployBPMFileResp>('post', `${this.basePath}/bpmutils/activiti/deployBPMNFile`,
      {
        body: convertFormParamsToString ? formParams.toString() : formParams,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 流程資源部署
   * 流程資源路徑部署
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deployResourceFilesUsingPOST(body?: ActivitiDeployProcessReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiDeployProcessResp>;
  public deployResourceFilesUsingPOST(body?: ActivitiDeployProcessReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiDeployProcessResp>>;
  public deployResourceFilesUsingPOST(body?: ActivitiDeployProcessReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiDeployProcessResp>>;
  public deployResourceFilesUsingPOST(body?: ActivitiDeployProcessReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiDeployProcessResp>('post', `${this.basePath}/bpmutils/activiti/deployResourceFiles`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 目前停留在那些節點(含前一關)
   * 查詢流程目前停留節點(含前一關)資訊
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCurrentTasksUsingPOST(body?: ActivitiQueryCurrentTaskReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQueryCurrentTaskResp>;
  public getCurrentTasksUsingPOST(body?: ActivitiQueryCurrentTaskReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQueryCurrentTaskResp>>;
  public getCurrentTasksUsingPOST(body?: ActivitiQueryCurrentTaskReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQueryCurrentTaskResp>>;
  public getCurrentTasksUsingPOST(body?: ActivitiQueryCurrentTaskReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQueryCurrentTaskResp>('post', `${this.basePath}/bpmutils/activiti/getCurrentTasks`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢流程定義任務
   * 查詢流程定義任務
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProcessDefTasksUsingPOST(body?: ActivitiProcessDefTasksReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiProcessDefTasksResp>;
  public getProcessDefTasksUsingPOST(body?: ActivitiProcessDefTasksReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiProcessDefTasksResp>>;
  public getProcessDefTasksUsingPOST(body?: ActivitiProcessDefTasksReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiProcessDefTasksResp>>;
  public getProcessDefTasksUsingPOST(body?: ActivitiProcessDefTasksReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiProcessDefTasksResp>('post', `${this.basePath}/bpmutils/activiti/getProcessDefTasks`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 取得流程圖 Base64 位元字串
   * 取得流程圖(SVG) Base64 位元字串
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProcessImgByPIDUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiProcessImgResp>;
  public getProcessImgByPIDUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiProcessImgResp>>;
  public getProcessImgByPIDUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiProcessImgResp>>;
  public getProcessImgByPIDUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiProcessImgResp>('post', `${this.basePath}/bpmutils/activiti/getProcessImgByPID`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢案件歷程
   * 查詢案件歷程內容
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProcessInstanceCommentsUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQueryProcessInstanceResp>;
  public getProcessInstanceCommentsUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQueryProcessInstanceResp>>;
  public getProcessInstanceCommentsUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQueryProcessInstanceResp>>;
  public getProcessInstanceCommentsUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQueryProcessInstanceResp>('post', `${this.basePath}/bpmutils/activiti/getProcessInstanceComments`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 取得流程變數
   * 取得流程指定變數內容
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProcessVariableUsingPOST(body?: ActivitiQueryProcessVariableReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiProcessVariableResp>;
  public getProcessVariableUsingPOST(body?: ActivitiQueryProcessVariableReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiProcessVariableResp>>;
  public getProcessVariableUsingPOST(body?: ActivitiQueryProcessVariableReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiProcessVariableResp>>;
  public getProcessVariableUsingPOST(body?: ActivitiQueryProcessVariableReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiProcessVariableResp>('post', `${this.basePath}/bpmutils/activiti/getProcessVariable`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 取得流程變數
   * 取得流程全部變數
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getProcessVariablesUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiProcessVariablesResp>;
  public getProcessVariablesUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiProcessVariablesResp>>;
  public getProcessVariablesUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiProcessVariablesResp>>;
  public getProcessVariablesUsingPOST(body?: ActivitiQueryProcessInstanceReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiProcessVariablesResp>('post', `${this.basePath}/bpmutils/activiti/getProcessVariables`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢代理人歷程
   * 查詢代理人歷程
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSubstitutionHisUsingPOST(body?: ActivitiQuerySubstitutionHisReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQuerySubstitutionHisResp>;
  public getSubstitutionHisUsingPOST(body?: ActivitiQuerySubstitutionHisReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQuerySubstitutionHisResp>>;
  public getSubstitutionHisUsingPOST(body?: ActivitiQuerySubstitutionHisReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQuerySubstitutionHisResp>>;
  public getSubstitutionHisUsingPOST(body?: ActivitiQuerySubstitutionHisReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQuerySubstitutionHisResp>('post', `${this.basePath}/bpmutils/activiti/getSubstitutionHis`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢代理職待辦事項數量
   * 查詢代理職待辦事項數量
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSubstitutionTodoListCountingUsingPOST(body?: ActivitiQuerySubstitutionCountReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQuerySubstitutionCountResp>;
  public getSubstitutionTodoListCountingUsingPOST(body?: ActivitiQuerySubstitutionCountReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQuerySubstitutionCountResp>>;
  public getSubstitutionTodoListCountingUsingPOST(body?: ActivitiQuerySubstitutionCountReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQuerySubstitutionCountResp>>;
  public getSubstitutionTodoListCountingUsingPOST(body?: ActivitiQuerySubstitutionCountReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQuerySubstitutionCountResp>('post', `${this.basePath}/bpmutils/activiti/getSubstitutionTodoListCounting`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢代理職待辦事項
   * 查詢代理職待辦事項
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSubstitutionTodoListUsingPOST(body?: ActivitiQuerySubstitutionReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQuerySubstitutionResp>;
  public getSubstitutionTodoListUsingPOST(body?: ActivitiQuerySubstitutionReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQuerySubstitutionResp>>;
  public getSubstitutionTodoListUsingPOST(body?: ActivitiQuerySubstitutionReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQuerySubstitutionResp>>;
  public getSubstitutionTodoListUsingPOST(body?: ActivitiQuerySubstitutionReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQuerySubstitutionResp>('post', `${this.basePath}/bpmutils/activiti/getSubstitutionTodoList`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢案件資訊
   * 查詢案件資訊
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTaskInfoByIDUsingPOST(body?: ActivitiQueryTaskReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQueryTaskResp>;
  public getTaskInfoByIDUsingPOST(body?: ActivitiQueryTaskReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQueryTaskResp>>;
  public getTaskInfoByIDUsingPOST(body?: ActivitiQueryTaskReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQueryTaskResp>>;
  public getTaskInfoByIDUsingPOST(body?: ActivitiQueryTaskReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQueryTaskResp>('post', `${this.basePath}/bpmutils/activiti/getTaskInfoByID`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢待辦數量
   * 查詢待辦數量
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTodoListCountingUsingPOST(body?: ActivitiQueryPendingCountReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQueryPendingCountResp>;
  public getTodoListCountingUsingPOST(body?: ActivitiQueryPendingCountReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQueryPendingCountResp>>;
  public getTodoListCountingUsingPOST(body?: ActivitiQueryPendingCountReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQueryPendingCountResp>>;
  public getTodoListCountingUsingPOST(body?: ActivitiQueryPendingCountReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQueryPendingCountResp>('post', `${this.basePath}/bpmutils/activiti/getTodoListCounting`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 查詢待辦清單
   * 查詢待辦清單
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTodoListUsingPOST(body?: ActivitiQueryPendingReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiQueryPendingResp>;
  public getTodoListUsingPOST(body?: ActivitiQueryPendingReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiQueryPendingResp>>;
  public getTodoListUsingPOST(body?: ActivitiQueryPendingReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiQueryPendingResp>>;
  public getTodoListUsingPOST(body?: ActivitiQueryPendingReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiQueryPendingResp>('post', `${this.basePath}/bpmutils/activiti/getTodoList`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 改派處理者
   * 改派處理(Assignee)者
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public setAssigneeUsingPOST(body?: ActivitiSetAssigneeReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiSetAssigneeResp>;
  public setAssigneeUsingPOST(body?: ActivitiSetAssigneeReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiSetAssigneeResp>>;
  public setAssigneeUsingPOST(body?: ActivitiSetAssigneeReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiSetAssigneeResp>>;
  public setAssigneeUsingPOST(body?: ActivitiSetAssigneeReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiSetAssigneeResp>('post', `${this.basePath}/bpmutils/activiti/setAssignee`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 啟動流程
   * 啟動流程
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public startProcessUsingPOST(body?: ActivitiStartProcessReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiStartProcessResp>;
  public startProcessUsingPOST(body?: ActivitiStartProcessReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiStartProcessResp>>;
  public startProcessUsingPOST(body?: ActivitiStartProcessReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiStartProcessResp>>;
  public startProcessUsingPOST(body?: ActivitiStartProcessReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiStartProcessResp>('post', `${this.basePath}/bpmutils/activiti/startProcess`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * 強制終止流程
   * 強制終止流程
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public terminateProcessUsingPOST(body?: ActivitiTerminateProcessReq, observe?: 'body', reportProgress?: boolean): Observable<ActivitiTerminateProcessResp>;
  public terminateProcessUsingPOST(body?: ActivitiTerminateProcessReq, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ActivitiTerminateProcessResp>>;
  public terminateProcessUsingPOST(body?: ActivitiTerminateProcessReq, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ActivitiTerminateProcessResp>>;
  public terminateProcessUsingPOST(body?: ActivitiTerminateProcessReq, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ActivitiTerminateProcessResp>('post', `${this.basePath}/bpmutils/activiti/terminateProcess`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * test
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public testUsingGET(observe?: 'body', reportProgress?: boolean): Observable<string>;
  public testUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
  public testUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
  public testUsingGET(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json;charset=UTF-8'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<string>('get', `${this.basePath}/bpmutils/activiti/test`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
